// extracted by mini-css-extract-plugin
export var assigneeBadge = "_o0-0";
export var assigneeDetails = "_o0-1";
export var assigneeInfo = "_o0-2";
export var dropdownContainer = "_o0-4";
export var dropdownImage = "_o0-5";
export var editAssigneeInfo = "_o0-3";
export var editAssigneeModalContainer = "_o0-6";
export var hidden = "_o0-8";
export var input = "_o0-7";